@if (!isDefaultTypeAhead) {
  <div
    [ngClass]="{ 'p-1': !app.thread.isEditMode() }"
    >
    <!-- the suggestions are displayed currently only for the crtNumber and the partNumber -->
    @if (app.unlockedId != null && app.model[field] === '') {
      <div>
        @for (id of app.manufacturer.getListOfSuggestions(field); track id) {
          <span
            class="badge badge-light"
            ><a (click)="selectValue(id)" class="pointer dark-text">
            {{ id }} &nbsp;
          </a></span
          >
        }
      </div>
    }
    <!-- value displayed in read mode -->
    @if (
      (this.app.unlockedId == null &&
      !app.field.isHyperLink(field, docModel[field])) ||
      (!app.post.isReadMode && !app.field.isHyperLink(field, docModel[field]))
      ) {
      <span
        >{{ docModel[field] }}</span
        >
      }
      @if (app.field.isHyperLink(field, docModel[field])) {
        <a
          class="lineHeight-28"
          [ngClass]="{ link: app.field.isHyperLink(field, docModel[field]) }"
          (click)="app.routing.openInNewTab(null, field, docModel[field])"
          >{{ docModel[field] }}</a
          >
        }
        <!-- displayed in edit mode -->
        @if (
          app.unlockedId != null &&
          app.fieldId.thread.cageCode === field &&
          app.field.manufacturerCodes.length > 1
          ) {
          <div
            >
            @for (code of app.field.manufacturerCodes; track code) {
              <span
                class="badge badge-light"
                ><a
                (click)="app.field.setManufacturerCode(code)"
                class="pointer dark-text sm-text"
                >
                {{ code }} &nbsp;
              </a></span
              >
            }
          </div>
        }
        @if (app.unlockedId != null && app.post.isReadMode) {
          <div
            class="input-group typeAhead"
            >
            @if (docModel[field] !== '') {
              <button
                class="btn btn-sm selected"
                type="button"
                (click)="clearContent(field)"
                >
                {{ docModel[field] }}
                <i class="fa fa-times app-subtle"></i>
              </button>
            }
            @if (!selected && docModel[field] == '') {
              <input
                id="typeahead-basic"
                type="text"
                class="form-control inputStyle"
                [(ngModel)]="app.typeAheadBasic.model[field]"
                (focusout)="saveInput(app.typeAheadBasic.model[field])"
                [maxLength]="maxLength"
                [placeholder]="placeholder"
                (keyup)="onKeyUp($event)"
                (keydown.Enter)="onEnter()"
                />
            }
            @if (
              app.field.isRequired(field) &&
              !app.field.isValid(field, docModel[field])
              ) {
              <span
                class="invalidspan mx-1"
                ><i
                class="fal fa-exclamation-circle"
                tooltipClass="customTooltip"
                [ngbTooltip]="app.text.field.requiredIcon"
                ></i
              ></span>
            }
          </div>
        }
        @if (showDropdownList) {
          <div
            class="optionList"
            [ngClass]="{ listTop: displayOptionsTop, listBottom: !displayOptionsTop }"
            >
            <ul>
              @for (item of ids; track item) {
                <li
                  class="dropdown-item pointer"
                  (click)="selectValue(item)"
                  >
                  {{ item }}
                </li>
              }
            </ul>
          </div>
        }
      </div>
    }
    @if (isDefaultTypeAhead) {
      <div class="input-group">
        @if (isInvalid(app.typeAheadBasic.model[field])) {
          <div
            class="col-sm-12 small text-danger"
            >
            {{ app.text.app.fieldInvalid }}
          </div>
        }
        @if (isSelected(field)) {
          <button
            class="btn btn-sm selectedValue"
    [ngClass]="{
      selectedValueRM: app.type === 'rm.search',
      typeaheadFilters: app.type === 'thread'
    }"
            type="button"
            [disabled]="disabled()"
            (click)="clearContent(field)"
            >
            {{ selectedValue }}
            <i class="fa fa-times app-subtle"></i>
          </button>
        }
        @if (!isSelected(field)) {
          <input
            [ngClass]="{ typeaheadFilters: app.type === 'thread' }"
            id="{{ field }}"
            type="text"
            class="form-control inputStyle sortOptions"
            [(ngModel)]="app.typeAheadBasic.model[field]"
            [placeholder]="placeholder"
            (keyup)="onKeyUp($event)"
            (focusout)="resetInput()"
            (keydown.Enter)="onEnter()"
            />
        }
        @if (
          app.field.isRequired(field) &&
          !app.field.isValid(field, app.typeAheadBasic.model[field])
          ) {
          <span
            class="invalidspan"
            ><i
            class="fal fa-exclamation-circle"
            tooltipClass="customTooltip"
            [ngbTooltip]="app.text.field.requiredIcon"
            ></i
          ></span>
        }
        @if (
          app.type === 'rm.search' &&
          app.RMSearch.filterMode !== 'part.partNumber' &&
          app.RMSearch.filterMode !== 'manufacturer.manufacturerPartNumber' &&
          !isSelected(field)
          ) {
          <button
            class="btn searchButton"
            type="button"
    (click)="
      app.RMSearch.model = app.typeAheadBasic.model;
      app.RMSearch.getRMSearchResults()
    "
            >
            <i class="fa fa-search"></i>
            <span>&nbsp;{{ app.text.app.search }}</span>
          </button>
        }
        @if (showDropdownList) {
          <div
            class="optionList dropdown-menu listBottom"
            aria-labelledby="sortOptions"
            [ngClass]="{ responsibleList: isInvalid(app.typeAheadBasic.model[field]) }"
            >
            <ul>
              @for (item of ids; track item; let i = $index) {
                <li
                  id="id"
                  class="dropdown-item"
                  [class.hovering]="selectedItemIndex === i"
                  (mousedown)="selectValue(item)"
                  >
                  {{ item }}
                </li>
              }
            </ul>
          </div>
        }
      </div>
    }
